import { CREATE_SUBTEAM_LEVEL, EDITABLE_TEAM_LEVEL } from '../constants/globals';

export default <T extends { teamPathIds?: string }>({
  teamPathIds,
}: T): { editable: boolean; createSubteamAllowed: boolean } | null => {
  const level = teamPathIds?.split('/').length;

  if (!level) {
    return null;
  }

  return { editable: level > EDITABLE_TEAM_LEVEL, createSubteamAllowed: level > CREATE_SUBTEAM_LEVEL };
};
